import { render, staticRenderFns } from "./addOne.vue?vue&type=template&id=4aaff04a&scoped=true&"
import script from "./addOne.vue?vue&type=script&lang=js&"
export * from "./addOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaff04a",
  null
  
)

export default component.exports